import z from 'zod';
// `z.coerce.boolean()` is `Boolean(value)`, so the query string "false" parses as `true`. Query
// DTOs receive strings while forms built on the same schemas hold real booleans: accept both.
export const zodQueryBoolean = () => z.union([z.boolean(), z.stringbool()]);
